export enum EvaluationQuestionLinkTypeEnum {
  Video = 1,
  Image = 2,
  Code = 3,
}
